import { defineMessages } from 'react-intl';
import type { PackageState } from '@platform/shared';

export type Tone = 'ok' | 'warn' | 'bad' | 'neutral' | 'accent';

/** The nine lifecycle states (planning-app.md §3.3 *Package states*), as the board paints them. Their own module: the entity rail (components/related) reads them on the wireframe and document pages without the rest of the board's catalog. */
export const stateMessages = defineMessages({
  'blocked-on-decision': { id: 'plan.state.blocked-on-decision', defaultMessage: 'blocked on a decision', description: 'Package lifecycle state' },
  ready: { id: 'plan.state.ready', defaultMessage: 'ready', description: 'Package lifecycle state: prerequisites decided, not started' },
  building: { id: 'plan.state.building', defaultMessage: 'building', description: 'Package lifecycle state' },
  'verified-in-isolation': { id: 'plan.state.verified-in-isolation', defaultMessage: 'verified in isolation', description: 'Package lifecycle state' },
  'merged-dark': { id: 'plan.state.merged-dark', defaultMessage: 'merged dark', description: 'Package lifecycle state: merged behind its lever' },
  'in-soak': { id: 'plan.state.in-soak', defaultMessage: 'in soak', description: 'Package lifecycle state' },
  soaked: { id: 'plan.state.soaked', defaultMessage: 'soaked', description: 'Package lifecycle state' },
  enabled: { id: 'plan.state.enabled', defaultMessage: 'enabled', description: 'Package lifecycle state: the lever is on' },
  'legacy-removed': { id: 'plan.state.legacy-removed', defaultMessage: 'legacy removed', description: 'Package lifecycle state: the old path is gone' },
});

export const STATE_TONE: Record<PackageState, Tone> = {
  'blocked-on-decision': 'warn',
  ready: 'neutral',
  building: 'accent',
  'verified-in-isolation': 'accent',
  'merged-dark': 'ok',
  'in-soak': 'ok',
  soaked: 'ok',
  enabled: 'ok',
  'legacy-removed': 'ok',
};
